import React, { useState, useEffect } from 'react';
import { Col, Button, List, Input } from 'reactstrap';
import { ComponentCard } from '../layout/ComponentCard';
import { ModalClickable } from '../layout/ModalClickable';
import { ModalLoader } from '../layout/ModalLoader';
import { ModalApi } from '../layout/ModalApi';
import { Instancia } from '../helpers/axios';
import MyEditor from '../../../layouts/myEditor/MyEditor';
import usePasarelaActiva from '../../../hooks/usePasarelaActiva';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';
import { PASARELAS } from '../../../helpers/pasarelas';
import {
  todosModulosAnioSeleccionados,
  precioInscripcionSegunSeleccion,
} from '../../../helpers/actividades';
import logger from '../../../services/logger/logger';

// Importe fijo por cuota del plan de 6 pagos. A diferencia del resto de planes
// (que derivan de precioFinal / nº de cuotas), este es un valor plano.
// TODO(negocio): confirmar si los 260€ son una regla de negocio intencionada
// (producto de financiación a precio fijo) o un valor heredado que debería
// parametrizarse/derivarse del precio del ciclo.
const CUOTA_SEIS_PAGOS = 260;

export const Resumen = ({
  local,
  userSession,
  previous,
  modulos,
  nombreGrupo,
  codigoGrupo,
  beginning,
  id,
  empresaId,
  variant,
  deployment,
  idDelegacion,
  excepcion,
  actividades,
  paymentType,
  paymentMethod,
  selectedOption,
  isSede,
  isFirstPeriod,
  precioFinal,
  descuento,
  isPresencial,
  usesD2L,
  mode = 'matricula',
  cuotaDates,
}) => {
  // En presupuesto el alumno puede ser un lead puro (isLead=true) o un alumno
  // ya existente (isLead=false). Mantenemos compat: si no hay flag en storage,
  // asumimos true para presupuesto, false para matrícula.
  const isLeadFlag =
    mode === 'presupuesto' ? (local.isLead === undefined ? true : !!local.isLead) : false;
  const leadParam = isLeadFlag ? '&isLead=true' : '';
  const { pasarela } = usePasarelaActiva(empresaId);
  const soloLectura = useSoloLecturaMatriculas();
  const pasarelaOnline = pasarela || PASARELAS.STRIPE;
  let tipoPago = '';
  let metodoPago = '';
  let pagoCuota = 0;
  if (paymentMethod === 'tarjetaCredito') {
    metodoPago = 'Tarjeta de crédito';
  } else if (paymentMethod === 'efectivo') {
    metodoPago = 'Efectivo';
  } else if (paymentMethod === 'transferencia') {
    metodoPago = 'Transferencia';
  } else {
    metodoPago = pasarelaOnline;
  }

  if (paymentType === 'pagoUnico') {
    tipoPago = 'Pago único';

    pagoCuota = precioFinal;
  } else if (paymentType === 'sinRecibo') {
    tipoPago = 'Sin recibo';

    pagoCuota = precioFinal;
  } else if (paymentType === 'pagoDosCuotas') {
    tipoPago = 'Pago en dos cuotas';

    pagoCuota = Math.ceil(precioFinal / 2);
  } else if (paymentType === 'pagoCuatroCuotas') {
    tipoPago = 'Pago en cuatro cuotas';

    pagoCuota = precioFinal / 4;
  } else if (paymentType === 'pagoDoceCuotas') {
    tipoPago = 'Pago en doce cuotas';

    pagoCuota = Math.trunc(precioFinal / 12);
  } else if (paymentType === 'pagoOnceCuotas') {
    tipoPago = 'Pago en once cuotas';

    pagoCuota = precioFinal / 11;
  } else if (paymentType === 'pagoCincoCuotas') {
    tipoPago = 'Pago en cinco cuotas';

    pagoCuota = precioFinal / 5;
  } else if (paymentType === 'pagoSeisCuotas') {
    tipoPago = 'Pago en seis cuotas';

    pagoCuota = CUOTA_SEIS_PAGOS;
  } else {
    tipoPago = 'Pago en diez cuotas';

    pagoCuota = precioFinal / 10;
  }
  // Preparamosvariables necesarias
  const [, setIsEnabled] = useState(true);
  const [type, setType] = useState([]);
  const [dataPrecio, setDataPrecio] = useState([]);
  const [precioCuota, setPrecioCuota] = useState(0);
  const [isSaved] = useState(false);
  const [isLoading] = useState(false);
  const [idState] = useState('');
  const [raw, setRaw] = useState('');
  const [comentario, setComentario] = useState('');
  const [comentarioExt, setComentarioExt] = useState('');
  const [isSavingPresupuesto, setIsSavingPresupuesto] = useState(false);
  const [presupuestoSaved, setPresupuestoSaved] = useState(false);
  const [presupuestoIdSaved, setPresupuestoIdSaved] = useState(null);
  const [presupuestoError, setPresupuestoError] = useState('');
  const [precioDif, setPrecioDif] = useState(false);
  const [, setCont] = useState(0);
  const [isNewStudent, setIsNewStudent] = useState(false);
  const [preciosEditados, setPreciosEditados] = useState({});
  const actividadesResult = Object.values(actividades).reduce((acc, moduleArray) => {
    return acc.concat(moduleArray);
  }, []);
  const [modalApi, setModalApi] = useState(false);
  const isCae = nombreGrupo.includes('CAE');
  const isOnline = nombreGrupo.includes('NP');

  const calcularPrecioCuota = () => {
    if (!dataPrecio.length || !dataPrecio[0].precioCiclo) return 0;
    const precioCiclo = dataPrecio[0].precioCiclo;

    if (selectedOption !== '1') {
      return pagoCuota;
    }
    // selectedOption === "1" => matrícula completa
    switch (paymentType) {
      case 'pagoUnico':
      case 'sinRecibo':
        return precioCiclo;

      case 'pagoDosCuotas':
        return precioCiclo / 2;

      case 'pagoCuatroCuotas':
      case 'pagoDiezCuotas':
        return isCae && !isOnline
          ? precioCiclo / 14
          : paymentType === 'pagoCuatroCuotas'
          ? precioCiclo / 4
          : precioCiclo / 10;

      case 'pagoOnceCuotas':
        return precioCiclo / 11;

      case 'pagoDoceCuotas':
        if (isOnline && !isCae) return (precioCiclo * 2) / 17;
        return precioCiclo / 12;

      case 'pagoCincoCuotas':
        if (isOnline && !isCae) return (precioCiclo * 2) / 17;
        return precioCiclo / 5;

      case 'pagoSeisCuotas':
        return precioCuota;

      default:
        return precioCiclo / 10; // fallback
    }
  };
  const precioCuotaFinal = calcularPrecioCuota();

  const filteredData = actividadesResult.filter((item) =>
    modulos.includes(`${item.modulo} ${item.descripcion}`),
  );

  const actividadKey = (item) => `${item.modulo}|${item.codigo}|${item.descripcion}`;

  // Sanea el importe permitiendo decimales: convierte coma en punto y deja solo
  // dígitos y un único separador decimal. Se guarda como string controlado para no
  // romper estados intermedios mientras se teclea (p.ej. "152.").
  const sanitizePrecio = (raw) => {
    let s = String(raw).replace(',', '.').replace(/[^\d.]/g, '');
    const firstDot = s.indexOf('.');
    if (firstDot !== -1) {
      s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
    }
    return s;
  };

  const getPrecioActividad = (item) => {
    const k = actividadKey(item);
    if (preciosEditados[k] !== undefined) return preciosEditados[k];
    const base = precioDif ? item.importe_suelto : item.precio;
    const n = parseFloat(base);
    return Number.isFinite(n) ? n : 0;
  };

  const precioNumActividad = (item) => {
    const n = parseFloat(getPrecioActividad(item));
    return Number.isFinite(n) ? n : 0;
  };

  const handlePrecioActividadChange = (item, raw) => {
    setPreciosEditados((prev) => ({ ...prev, [actividadKey(item)]: sanitizePrecio(raw) }));
  };

  const totalActividadesEditado = filteredData.reduce(
    (sum, it) => sum + precioNumActividad(it),
    0,
  );

  useEffect(() => {
    let total = 0; // Usamos una variable local para acumular el precio

    filteredData.forEach((item) => {
      total += item.importe_suelto; // Acumulamos el precio en total
    });

    setCont(total); // Actualizamos el estado con el valor total

    if (total === precioFinal) {
      setPrecioDif(true);
    } else {
      setPrecioDif(false);
    }
  }, [filteredData, precioFinal]);

  const handleComentarioChange = (event) => {
    setComentario(event.target.value);
  };

  const fullName = `${local.nombre} ${local.apellidos}`;

  // Efectos
  useEffect(() => {
    peticionesApi();
  }, []);

  // Función para las peticiones a API
  const peticionesApi = async () => {
    // Salvaguarda: si todavía no tenemos alumno/lead o grupo, no llamamos al
    // backend con `id=` vacío (provoca 400 en /buscarPreciosCiclo).
    if (!local?.id || !id) return;

    // Declaramos instancia de axios
    const instance = Instancia(deployment);

    const grupos = await instance.get(
      `nuevoEstudiante?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&id=${local.id}&name=${nombreGrupo}${leadParam}`,
    );

    // grupos.data.estado === true => alumno nuevo. Lo guardamos en estado para
    // usarlo más tarde (p.ej. en el raw de saveEnrollment), pero OJO: aquí abajo
    // NO podemos leer isNewStudent todavía (setState es asíncrono y el closure
    // mantiene el valor previo); usamos directamente esNuevoAlumno.
    const esNuevoAlumno = grupos.data.estado;
    setIsNewStudent(esNuevoAlumno);

    // peticiones a la API
    try {
      // Petición para obtener el precio del curso
      const precioCurso = await instance.get(
        `buscarPreciosCiclo?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&id=${local.id}&groupId=${id}&descuento=${descuento.id}&nuevo=${grupos.data.estado}${leadParam}`,
      );

      if (isOnline && !esNuevoAlumno && selectedOption === '1') {
        setPrecioCuota(precioCurso.data[0].precio_ciclo_cuota);
      } else {
        setPrecioCuota(precioCurso.data[0].precio);
      }
      setDataPrecio(precioCurso.data);
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en Resumen:', error);
      sessionStorage.setItem('apiError', error);
    }
    // peticiones a la API
    try {
      // Petición para obtener tipos de curso
      const tipos = await instance.get(
        `buscarTipos?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&codigoGrupo=${codigoGrupo}&studentId=${local.id}${leadParam}`,
      );
      setType(tipos.data);
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en Resumen:', error);
      sessionStorage.setItem('apiError', error);
    }

    if (modulos.length > 0) {
      setIsEnabled(false);
    }
  };
  // Función para guardar la petición de matrícula
  const saveEnrollment = async () => {
    const raw = JSON.stringify({
      ccodcli: local.id,
      nombre: local.nombre,
      idGrupo: id,
      headquarter: empresaId,
      userEmail: userSession?.profileObj.email,
      modulos: modulos,
      origen: variant,
      empresaOrigen: local.empresaId,
      excepcion: excepcion,
      idDelegacion:
        local.empresaId === 'CEDESCA'
          ? idDelegacion.idCedesca
          : local.empresaId === 'CNTEC'
          ? idDelegacion.idCntec
          : idDelegacion.idCedesca,
      precioTotal: precioFinal,
      precioIns:
        dataPrecio[0].precio - (dataPrecio[0].precio * dataPrecio[0].porcentaje_descuento) / 100,
      precioCiclo: dataPrecio[0].precioCiclo,
      precioC: precioCuotaFinal,
      metodoPago: paymentMethod,
      tipoPago: paymentType,
      nombreCiclo: nombreGrupo,
      tipoMatricula: selectedOption,
      comentario: comentario,
      isSede: isSede,
      isFirstPeriod: isFirstPeriod,
      isPresencial: isPresencial,
      isOnline: isOnline,
      isNewStudent: isNewStudent,
    });
    setRaw(raw);
    setModalApi(true);
  };

  const savePresupuesto = async () => {
    setIsSavingPresupuesto(true);
    setPresupuestoError('');
    try {
      const instance = Instancia(deployment);
      const actividadesFormatted = Object.values(actividades)
        .flat()
        .filter((a) => modulos.includes(`${a.modulo} ${a.descripcion}`))
        .map((a) => ({
          codigocurso: a.codigo,
          descripcion: a.descripcion,
          idAgrupado: a.modulo,
          idPlan: a.nombre,
          precio: precioNumActividad(a),
        }));

      const cuotasMap = {
        pagoUnico: 1,
        sinRecibo: 1,
        pagoDosCuotas: 2,
        pagoTresCuotas: 3,
        pagoCuatroCuotas: 4,
        pagoCincoCuotas: 5,
        pagoSeisCuotas: 6,
        pagoSieteCuotas: 7,
        pagoOchoCuotas: 8,
        pagoNueveCuotas: 9,
        pagoDiezCuotas: 10,
        pagoOnceCuotas: 11,
        pagoDoceCuotas: 12,
      };

      const cuotasPayload = Array.isArray(paymentType)
        ? Array.from(new Set(paymentType.map((k) => cuotasMap[k]).filter(Boolean))).sort(
            (a, b) => a - b,
          )
        : cuotasMap[paymentType] || 1;

      const response = await instance.post('presupuestos', {
        headquarter: empresaId,
        isLead: true,
        idLead: local.id,
        ccodcli: local.id,
        idcurso: id,
        codigogrupo: codigoGrupo,
        idaño: '',
        idusuario: userSession?.profileObj?.email || '',
        estado: 0,
        // Matrícula completa (todos los módulos de 1er año seleccionados) -> precio;
        // selección parcial -> importe_suelto. Se envía el mismo valor que se muestra.
        // El backend además recalcula: si llega un precio de tarifa que no cuadra con
        // la selección, lo corrige (los precios manuales no los toca).
        precio_inscr: precioInscripcionSegunSeleccion(
          dataPrecio,
          todosModulosAnioSeleccionados(actividades, modulos, 'PRIMERO'),
        ),
        coment_int: comentario,
        coment_ext: comentarioExt,
        cuotas: cuotasPayload,
        actividades: actividadesFormatted,
      });

      const presupuestoId = response?.data?.Id_presupuesto || response?.data?.id || response?.data?.Id;
      if (presupuestoId) {
        setPresupuestoIdSaved(presupuestoId);
      }

      // Crear planes de pago (presu_pagos) para cada cuota seleccionada con fecha inicio.
      if (
        presupuestoId &&
        Array.isArray(paymentType) &&
        paymentType.length > 0 &&
        cuotaDates
      ) {
        const planes = paymentType
          .map((key) => {
            const n = cuotasMap[key];
            const dates = cuotaDates?.[key] || {};
            if (!n || !dates.inicio) return null;
            return {
              headquarter: empresaId,
              presu_id: presupuestoId,
              Cuotas: n,
              Fecha_ini: dates.inicio,
              Fecha_fin: dates.fin || null,
              tipo: dates.tipo || null,
            };
          })
          .filter(Boolean);

        if (planes.length > 0) {
          try {
            await Promise.all(planes.map((body) => instance.post('presupuesto/pagos', body)));
          } catch (planError) {
            logger.error('Error guardando planes de pago:', planError);
            setPresupuestoError(
              planError?.response?.data?.message ||
                'Presupuesto guardado, pero hubo un error al guardar los planes de pago.',
            );
          }
        }
      }

      setPresupuestoSaved(true);
    } catch (error) {
      logger.error('Error guardando presupuesto:', error);
      const backendMsg = error?.response?.data?.message || error?.response?.data?.error;
      const status = error?.response?.status;
      setPresupuestoError(
        backendMsg || `Error al guardar el presupuesto${status ? ` (${status})` : ''}.`,
      );
    } finally {
      setIsSavingPresupuesto(false);
    }
  };

  return (
    <>
      {isSavingPresupuesto && <ModalLoader header="Guardando presupuesto..." />}
      {presupuestoSaved && (
        <ModalClickable
          header="Presupuesto guardado correctamente."
          url={
            presupuestoIdSaved
              ? `/presupuestos/${(empresaId || '').toString().toLowerCase()}/${presupuestoIdSaved}`
              : '/presupuestos'
          }
        />
      )}
      {presupuestoError && <ModalClickable header={presupuestoError} />}
      {isLoading && idState === '' ? <ModalLoader /> : ''}
      {modalApi && idState === '' && raw !== '' ? (
        <ModalApi
          header="Guardando matrícula"
          raw={raw}
          deployment={deployment}
          setRaw={setRaw}
          mp={metodoPago}
          usesD2L={usesD2L}
        />
      ) : (
        ''
      )}
      {isSaved && idState !== '' && !isLoading ? (
        <ModalClickable
          header={
            idDelegacion.idCedesca <= 0 || idDelegacion.idCntec <= 0
              ? `Matrícula creada con id ${idState}`
              : `Petición de matrícula creada con id ${idState}`
          }
          url={`/solicitudes-matricula/${(empresaId || '')
            .toString()
            .toLowerCase()}/${idState}/revision`}
        />
      ) : (
        ''
      )}
      <Col md="12">
        <ComponentCard
          title={`Resumen - ${empresaId}`}
          hasButton={false}
          className="clearfix"
          name={fullName}
        >
          <h4>Curso</h4>
          <List>
            <li>{nombreGrupo}</li>
          </List>
          <h4>Actividades</h4>
          {mode === 'presupuesto' ? (
            <div className="mb-3">
              {filteredData.map((value) => (
                <div
                  key={`${value.modulo}-${value.codigo}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '6px 0',
                    borderBottom: '1px solid #f1f5f9',
                  }}
                >
                  <span style={{ flex: 1 }}>
                    <strong>{value.codigo}</strong> {value.descripcion}{' '}
                    <span style={{ color: '#64748b' }}>{value.horas}h</span>
                  </span>
                  <Input
                    type="text"
                    inputMode="decimal"
                    aria-label={`Precio ${value.codigo}`}
                    style={{ width: '110px', textAlign: 'right' }}
                    value={getPrecioActividad(value)}
                    onChange={(e) => handlePrecioActividadChange(value, e.target.value)}
                  />
                  <span style={{ width: '12px' }}>€</span>
                </div>
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                  marginTop: '8px',
                  fontWeight: 700,
                }}
              >
                <span>Total actividades:</span>
                <span data-testid="total-actividades">{totalActividadesEditado.toFixed(2)} €</span>
              </div>
            </div>
          ) : (
            <List>
              {filteredData.sort().map((value) => (
                <li key={value.codigo}>
                  {value.codigo} {value.descripcion} {value.horas}h{' '}
                  {precioDif ? value.importe_suelto : value.precio}€
                </li>
              ))}
            </List>
          )}
          <h4>Tipo matrícula</h4>
          <List>
            <li>{selectedOption === '1' ? 'Matrícula completa' : 'Matrícula personalizada'}</li>
          </List>
          {mode === 'presupuesto' && Array.isArray(paymentType) && paymentType.length > 0 && (() => {
            const labelByKey = {
              pagoUnico: '1 cuota',
              pagoDosCuotas: '2 cuotas',
              pagoTresCuotas: '3 cuotas',
              pagoCuatroCuotas: '4 cuotas',
              pagoCincoCuotas: '5 cuotas',
              pagoSeisCuotas: '6 cuotas',
              pagoSieteCuotas: '7 cuotas',
              pagoOchoCuotas: '8 cuotas',
              pagoNueveCuotas: '9 cuotas',
              pagoDiezCuotas: '10 cuotas',
              pagoOnceCuotas: '11 cuotas',
              pagoDoceCuotas: '12 cuotas',
            };
            const cuotasCountMap = {
              pagoUnico: 1,
              pagoDosCuotas: 2,
              pagoTresCuotas: 3,
              pagoCuatroCuotas: 4,
              pagoCincoCuotas: 5,
              pagoSeisCuotas: 6,
              pagoSieteCuotas: 7,
              pagoOchoCuotas: 8,
              pagoNueveCuotas: 9,
              pagoDiezCuotas: 10,
              pagoOnceCuotas: 11,
              pagoDoceCuotas: 12,
            };
            // El desglose por cuota se calcula sobre el total de actividades EDITADO,
            // para que las cuotas se recalculen al ajustar los precios por módulo.
            const totalCuotas = totalActividadesEditado;
            const desglose = paymentType
              .map((key) => ({ key, n: cuotasCountMap[key] || 0 }))
              .filter((it) => it.n > 0)
              .sort((a, b) => a.n - b.n);
            const formatFecha = (iso) => {
              if (!iso) return '—';
              const [y, m, d] = iso.split('-');
              return `${d}/${m}/${y}`;
            };
            const tipoLabelByValue = { 1: 'U', 2: 'Y', 3: 'A' };
            return (
              <>
                <h4>Desglose por cuota</h4>
                <div
                  style={{
                    marginBottom: '16px',
                    padding: '12px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    backgroundColor: '#f9fafb',
                    fontSize: '0.85rem',
                  }}
                >
                  <div style={{ marginBottom: '8px', color: '#6b7280' }}>
                    Total: <strong>{totalCuotas.toFixed(2)} €</strong>
                  </div>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid #e5e7eb', color: '#6b7280' }}>
                        <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>
                          Opción
                        </th>
                        <th style={{ textAlign: 'right', padding: '6px 4px', fontWeight: 600 }}>
                          Importe
                        </th>
                        <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>
                          Fecha inicio
                        </th>
                        <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>
                          Tipo
                        </th>
                        <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>
                          Fecha fin
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {desglose.map(({ key, n }) => {
                        const porCuota = totalCuotas / n;
                        const inicio = cuotaDates?.[key]?.inicio || '';
                        const fin = cuotaDates?.[key]?.fin || '';
                        const tipo = cuotaDates?.[key]?.tipo || '';
                        return (
                          <tr key={key} style={{ borderTop: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '6px 4px', color: '#374151' }}>
                              {labelByKey[key] || key}
                            </td>
                            <td
                              style={{
                                padding: '6px 4px',
                                textAlign: 'right',
                                color: '#059669',
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {porCuota.toFixed(2)} €{n > 1 ? ' / cuota' : ''}
                            </td>
                            <td style={{ padding: '6px 4px', color: '#374151' }}>
                              {formatFecha(inicio)}
                            </td>
                            <td style={{ padding: '6px 4px', color: '#374151' }}>
                              {tipoLabelByValue[tipo] || '—'}
                            </td>
                            <td style={{ padding: '6px 4px', color: '#374151' }}>
                              {formatFecha(fin)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}
          {mode !== 'presupuesto' && (
            <>
              <h4>Precio inscripción</h4>
              <List>
                <li>
                  {dataPrecio.length > 0
                    ? dataPrecio[0].porcentaje_descuento > 0
                      ? `Precio Original: ${dataPrecio[0].precio}€ aplicado el ${
                          dataPrecio[0].porcentaje_descuento
                        }% resultando en ${(
                          dataPrecio[0].precio -
                          (dataPrecio[0].precio * dataPrecio[0].porcentaje_descuento) / 100
                        ).toFixed(2)}€`
                      : `${dataPrecio[0].precio}€`
                    : ''}
                </li>
              </List>
              <h4>Forma de pago</h4>
              <List>
                <li>
                  {tipoPago} / {metodoPago}
                </li>
              </List>
              <h4>Suma actividades</h4>
              <List>
                <li>{precioFinal}€</li>
              </List>
            </>
          )}
          <h4>{excepcion === '0' || excepcion === null ? '' : 'Excepción'}</h4>
          <List>
            {excepcion === '0' || excepcion === null ? <li>Sin excepción</li> : ''}
            {excepcion === '25' ? <li>Excepción del 25%</li> : ''}
            {excepcion === '50' ? <li>Excepción del 50%</li> : ''}
            {excepcion === '100' ? <li>Excepción del 100%</li> : ''}
          </List>
          <h4>Tipo de matrícula</h4>
          <List>{type.length > 0 ? <li>{type[0].tipo_de_curso}</li> : ''}</List>
          <h4>{mode === 'presupuesto' ? 'Comentario interno' : 'Comentarios'}</h4>
          {mode === 'presupuesto' ? (
            <div className="mb-3">
              <MyEditor
                content={comentario}
                setContent={setComentario}
                initHeight={250}
              />
            </div>
          ) : (
            <Input
              type="textarea"
              name="text"
              id="exampleText"
              className="mb-3"
              onChange={handleComentarioChange}
            />
          )}
          {mode === 'presupuesto' && (
            <>
              <h4>Comentario externo</h4>
              <div className="mb-5">
                <MyEditor
                  content={comentarioExt}
                  setContent={setComentarioExt}
                  initHeight={250}
                />
              </div>
            </>
          )}
          <div className="pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={previous}>Atrás</Button>
            <Button onClick={beginning}>
              {variant === 'portal' ? 'Volver a detalles' : 'Volver a la ficha de alumno'}
            </Button>
            <Button
              color="success"
              className="float-end"
              onClick={mode === 'presupuesto' ? savePresupuesto : saveEnrollment}
              disabled={isSavingPresupuesto || soloLectura}
            >
              {mode === 'presupuesto' ? 'Guardar presupuesto' : 'Finalizar'}
            </Button>
          </div>
        </ComponentCard>
      </Col>
    </>
  );
};
